<template>
  <div
    class="logo_bg c_cursor c_flex_row"
    @click="handleClick"
  >
    <!-- <el-image
      class="logo_img"
      :src="Logo"
      fit="fill"
    /> -->
    <span class="logo_name">储能云平台运营平台</span>
  </div>
</template>

<script lang="ts" setup>
import Logo from '@/assets/logo.png'
import { useRouter } from 'vue-router'

const router = useRouter()

const handleClick = () => {
  router.push({
    name: 'WorkBench',
  })
}
</script>

<style lang="less" scoped>
.logo_bg {
  text-align: center;
  height: 60px;
  line-height: 60px;

  .logo_img {
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 20px;
  }

  .logo_name {
    font-size: 20px;
    font-weight: bold;
    color: @mainDarkColor;
  }

  .spec_name {
    color: @whiteColor;
    font-size: 9px;
    background-color: @regularColor;
    padding: 2px;
    border-radius: 3px;
    vertical-align: top;
    margin-left: 5px;
  }
}
</style>
